var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import ReportStockService from "../../api/ReportStockService";
import GlobalVue from "../../globalVue";
import List from "./List.vue";
import QueryDetailList from './QueryDetailList.vue';
var QueryList = (function (_super) {
    __extends(QueryList, _super);
    function QueryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.showTabMenuPower = false;
        _this.TabMenuPowerId = 134;
        _this.TabMenuPowerAuthCode = '210002';
        return _this;
    }
    QueryList.prototype.created = function () {
        var _this = this;
        this.service = ReportStockService.getInstance();
        this.getAuth(this.TabMenuPowerAuthCode).then(function (pageAuth) {
            console.log('pageAuth', pageAuth);
            _this.TabMenuPowerPageAuth = pageAuth;
            _this.showTabMenuPower = !!pageAuth;
        });
    };
    QueryList.prototype.mounted = function () {
    };
    QueryList.prototype.tabBeforeLeave = function (tab, event) {
        if (tab == 1) {
            var pageAuth = this.TabMenuPowerPageAuth;
            GlobalVue.$emit('addTab', {
                component: QueryDetailList,
                title: '出入库明细',
                showExist: true,
                name: this.TabMenuPowerId,
                cprops: __assign({}, pageAuth.Response, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
            });
            return false;
        }
    };
    QueryList = __decorate([
        Component({
            components: {
                'stock-list': List
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], QueryList);
    return QueryList;
}(Vue));
export default QueryList;
